import { useState, useCallback } from "react";
export default function useToggle(initialState = false) {
    const [visible, setVisible] = useState(initialState);
    const toggle = useCallback((show) => {
        const _visible = typeof show === "boolean" ? show : !visible;
        setVisible(_visible);
        return _visible;
    }, [visible]);
    const show = useCallback(() => toggle(true), [toggle]);
    const hide = useCallback(() => toggle(false), [toggle]);
    return { toggle, show, hide, visible };
}
